import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { MOBILE_TABS } from './mobileNav';
import type { NavIconId } from './navIcons';

function TabIcon({ icon, active }: { icon: NavIconId; active: boolean }) {
  const stroke = active ? 'var(--gs-ink)' : 'var(--gs-muted)';
  const common = {
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none' as const,
    stroke,
    strokeWidth: 1.9,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true as const,
  };

  switch (icon) {
    case 'home':
      return (
        <svg {...common}>
          <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5Z" />
        </svg>
      );
    case 'screens':
      return (
        <svg {...common}>
          <rect x="3" y="4" width="18" height="12" rx="2" />
          <path d="M9 20h6M12 16v4" />
        </svg>
      );
    case 'library':
      return (
        <svg {...common}>
          <rect x="3.5" y="3.5" width="17" height="17" rx="2.5" />
          <circle cx="9" cy="9" r="1.6" />
          <path d="m20 15-4.5-4.5L6 20" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <circle cx="12" cy="8" r="3.5" />
          <path d="M5 19.5c1.8-3.2 4.2-4.8 7-4.8s5.2 1.6 7 4.8" />
        </svg>
      );
  }
}

/** Fixed companion tab bar — shown below `lg` only. */
export function MobileTabBar() {
  const { t } = useTranslation('layout');
  return (
    <nav
      className="shrink-0 border-t lg:hidden"
      style={{
        background: 'var(--gs-panel)',
        borderColor: 'var(--gs-line)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
      aria-label={t('nav.primary')}
    >
      <ul className="m-0 grid list-none grid-cols-4 gap-0 p-0">
        {MOBILE_TABS.map((tab) => (
          <li key={tab.to} className="min-w-0">
            <NavLink
              to={tab.to}
              {...(tab.end ? { end: true } : {})}
              className="flex flex-col items-center gap-1 px-1 py-2.5 text-[11px] font-semibold no-underline"
            >
              {({ isActive }) => (
                <span
                  className="flex flex-col items-center gap-1"
                  style={{ color: isActive ? 'var(--gs-ink)' : 'var(--gs-muted)' }}
                >
                  <TabIcon icon={tab.icon} active={isActive} />
                  <span className="truncate">{t(`nav.items.${tab.label}`)}</span>
                </span>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
